import React from "react";
import Button from "../button/default";
import Icon from "../icon";

export default function Token({
  filterName = "",
  attributes = {},
  onClick = null,
}) {
  return (
    <Button
      href="#"
      className="filter-token"
      attributes={attributes}
      onClick={onClick}
    >
      <span className="filter-token__filter-name">{filterName}</span>
      <Icon name="closer" />
    </Button>
  );
}
